import none from '../../img/leoLogo.png'

export const cooffee = [
  {
    "id": "221",
    "title": "سایفون",
    "desciption": "",
    "price": "160",
    "image": none
  },
  {
    "id": "222",
    "title": "فرانسه",
    "desciption": "",
    "price": "115",
    "image": none
  },
  {
    "id": "223",
    "title": "کلدبرو",
    "desciption": "",
    "price": "170",
    "image": none
  },
  {
    "id": "224",
    "title": "کمکس",
    "desciption": "",
    "price": "140",
    "image": none
  },

]